<template>
  <el-checkbox-group class="el-checkbox-group" v-model="valList" @change="onChange">
    <template v-for="item in options">
      <el-checkbox :label="item.value" :key="item.value" :disabled="item.disabled"
        >{{ item.displayName }} <span class="tips ft-12" v-if="item.tipText"> {{ item.tipText }}</span>
      </el-checkbox>
    </template>
  </el-checkbox-group>
</template>

<script>
import storeMixins from '../store-mixins';
export default {
  mixins: [storeMixins],
  props: ['props'],
  data() {
    return {
      valList: [],
    };
  },
  watch: {
    alibabaForm: {
      handler(v) {
        let formVal = v[this.key] || [];
        if (formVal.join(',') !== this.valList.join(',')) {
          const filterVal = formVal.filter(val => this.options.find(opt => opt.value === val))
          this.valList = filterVal;
          if(filterVal.length !== formVal.length) {
            this.onChange(filterVal)
          }
        }
      },
      deep: true,
    },
  },
  computed: {
    key() {
      return this.props.name;
    },
  },
  methods: {
    onChange(v) {
      const newFormFields = {};
      newFormFields[this.key] = v;
      if(this.key === 'supplyType' && !v.includes('2')) {
        newFormFields['kf'] = ''
      }
      this.updateAlibabaForm(newFormFields);
    },
  },
};
</script>
<style lang="scss" scoped>
.el-checkbox-group {
.tips {
    color: #ff7300;
  }
}
</style>